import { useState } from 'react'
import { Menu, X, ArrowRight } from 'lucide-react'
import { MobileNav } from './MobileNav'
import { NavDropdown } from './NavDropdown'
import { NavMegaMenu } from './NavMegaMenu'
import { ChromeLink } from './config'
import { navGroups, pricingLink } from './navigation'

export function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className="border-border bg-background/90 sticky top-0 z-40 w-full border-b backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
          <ChromeLink href="/" className="text-foreground flex flex-shrink-0 items-center gap-2.5">
            {/* width/height carry the SVG's intrinsic ratio (viewBox 669.4x736) so the
                browser reserves the right box before the file loads. CSS still sizes it;
                without these the header text shifts left-to-right on first paint. */}
            <img src="/logo-mark.svg" alt="" aria-hidden="true" width={669} height={736} className="h-9 w-auto" />
            <span className="text-3xl font-bold tracking-tight">Fugue Lab</span>
          </ChromeLink>

          {/* Desktop nav */}
          <nav aria-label="Main" className="hidden items-center gap-x-6 lg:flex">
            {navGroups.map((group) =>
              group.columns ? (
                <NavMegaMenu key={group.label} label={group.label} columns={group.columns} footer={group.footer} />
              ) : (
                <NavDropdown key={group.label} label={group.label} items={group.items} footer={group.footer} />
              )
            )}
            <ChromeLink
              href={pricingLink.href}
              className="text-muted-foreground hover:text-foreground text-sm transition"
            >
              {pricingLink.label}
            </ChromeLink>
            <ChromeLink
              href="/get-started"
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex items-center justify-center gap-1.5 rounded-md px-5 py-2 text-sm font-medium transition"
            >
              Get Started <ArrowRight className="h-4 w-4" />
            </ChromeLink>
          </nav>

          {/* Mobile toggle */}
          <div className="lg:hidden">
            <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </header>

      <MobileNav isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}
